import { Card, Divider, Tooltip } from "@mui/material";
import TabLabel from "components/pages/transmissions/tabs/label/TabLabel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React from "react";

const TaskStatusContainer = ({ status, children, count }) => {
  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Card
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: 12,
          boxShadow: "none",
          background: "#F5F5F5",
          margin: "0 10px 0 8px",
          border: "1px solid #E0E0E0",
          overflowY: "scroll",
          maxHeight: "85vh",
        }}
      >
        <p
          style={{
            color: "#757575",
            fontSize: "16px",
            fontWeight: "500",
            marginBottom: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              height: 28,
            }}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                lineHeight: "0.5",
                fontWeight: 600,
              }}
            >
              {status.toUpperCase()}
            </span>

            {status === "Completed" && (
              <Tooltip title="Completed tasks will be retained for 5 days before being removed automatically.">
                <InfoOutlinedIcon
                  style={{
                    fontSize: 18,
                    display: "inline-flex",
                    alignItems: "center",
                    lineHeight: "0.5",
                  }}
                />
              </Tooltip>
            )}

            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                lineHeight: "0.5",
              }}
            >
              <TabLabel count={count} />
            </span>
          </div>
        </p>
        <Divider />
        <div
          style={{
            marginTop: 8,
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </div>
      </Card>
    </div>
  );
};

export default TaskStatusContainer;
